<template lang="pug">
	.creative-vast-link
		Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions')")
		Popup(v-if="popupVisible", :popupVisible="popupVisible", :width="960", :autosize="true")
			.flex-col.space-medium
				.flex-row.space-large.align-center
					.font-big.upper {{$tCaption('VAST tag')}}
					DxSelectBox(v-if="encoders.length", :data-source="encoders", valueExpr="Oid", displayExpr="Name", :value.sync="selectedEncoderId", :width="350", stylingMode="filled")
				.flex-row.full-width.space.align-center
					Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions')")
					template(v-else)
						.dx-texteditor.flex-1.dx-editor-underlined
							.dx-texteditor-container
								.dx-texteditor-input-container
									input.dx-texteditor-input(ref="textbox", :value="finalVastLink")
						DxButton(icon="copy", @click="copyToClipboard")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
</template>

<script>
	import $ from 'jquery';
	import Loader from 'app-core/Loader.vue';
	import Popup from 'app-core/Popup.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import DxSelectBox from 'devextreme-vue/select-box';

	export default {
		translationCategory: 'creative.CreativeVastLink',
		name: 'creative-vast-link',
		components: {
			Loader, Popup, DxTextBox, DxButton, DxSelectBox
		},

		data() {
			return {
				isLoading: false,
				popupVisible: false,
				vastLink: null,
				encoders: [],
				selectedEncoderId: null
			};
		},
		computed: {
			selectedEncoder() {
				return this.encoders.find(f => f.Oid === this.selectedEncoderId);
			},
			finalVastLink() {
				return `${this.vastLink}&format=${this.selectedEncoder?.Code}`;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.vastLink = this;

			this.loadEncoders();
		},
		methods: {
			async loadEncoders() {
				this.encoders = (await this.$Data.getExternalApi('EncodingProfile/list', '', 9999, true))?.Results || [];
				this.selectedEncoderId = this.encoders[0]?.Oid;
			},
			open(creativeId, opts) {
				this.popupVisible = false;
				this.isLoading = true;
				this.vastLink = null;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.popupVisible = true;
				});
				let additionalParams = opts?.params ? `&${opts?.params}` : '';
				this.$Data.getExternalApi('Creative/GetCreativeVastUrl', `creativeId=${creativeId}`).then(r => {
					this.vastLink = r + additionalParams;
				}).finally(() => this.isLoading = false);
			},
			copyToClipboard() {
				$(this.$refs.textbox).select();
				try
				{
					var successful = document.execCommand('copy');
					var msg = successful ? this.$tCaption('VAST tag has been successfuly copied to clipboard') : this.$tCaption('VAST tag has been unsuccessfuly copied to clipboard');
					this.$notifySuccess(msg, 2000);
				}
				catch (err)
				{
					if (__DEGUG__)
						console.debug('Oops, unable to copy');
				}
				window.getSelection().removeAllRanges();
			}
		}
	};
</script>
<style lang='scss'>
	.creative-vast-link {
	}
</style>
